.stack-trace{white-space:pre;overflow-x:auto;display:block}
/*# sourceMappingURL=issue-entry.component-U3WGVPKO.css.map */
